<div class="bg_calculator">
  <app-headercontent></app-headercontent>
  <div class="container mb-3">
    <a class="back__link" [routerLink]="['/home']">Cambiar información</a>
  </div>
  <div class="bg_selected_car pt-3 pb-7">
    <div class="cont__select">
      <div class="container">
        <div class="row mb-2">
          <div class="col-md-12">
            <strong>Tu CUPRA:</strong>
          </div>
        </div>
        <form [formGroup]="dataform" (ngSubmit)="saveBudget()">
          <div *ngIf="newBudget" class="row">
            <div class="col-md-4">
              <img [src]="pathServer + newBudget.ModelVersion.ModelImage" alt="Tu CUPRA" class="img-fluid">
            </div>
            <div class="col-md-8 my__cupra">
              <div class="model">{{newBudget.ModelVersion.Model}}</div>
              <div class="motor">{{newBudget.ModelVersion.MotorType}}</div>
              <div class="version">{{newBudget.ModelVersion.Version}}</div>
            </div>
          </div>
          <div class="row mt-4 mb-5">
            <div class="col-md-12">
              <div class="border-bottom__subtitle">
                <strong>Información:</strong>
              </div>
            </div>
          </div>
          <!--Kilometraje-->
          <div *ngIf="valueKm !=0" class="row kms__my_cupra">

            <div class="col-md-auto type_data type_data_km">Kilometraje<br><small>(Introduce aquí tu km actual)</small></div>
            <div class="col">
              <ng5-slider [(value)]="valueKm" (valueChange)="valueKmChange($event)" [options]="options"></ng5-slider>
            </div>
            <div class="col-md-4">
              <div class="d-flex justify-content-end justify-content-md-start"><input type="number" (change)="changeKmValue(kmInput.value)" [value]="valueKm" #kmInput>
                <div class="input-group-append">
                  <span class="input-group-text"> km </span>
                </div>
              </div>
            </div>

          </div>
          <!--Meses-->
          <div class="row mt-3 mt-md-5 age__cupra">
            <div class="col-md-2 type_data">Edad</div>
            <div class="col-md-8">
              <div class="age__wrapper">
                <div class="floating-form">

                  <div class="d-flex">
                    <a class="plusminus minus" (click)="handleMinus()"></a>
                    <input type="number" min="0" step="1" formControlName="Months" [(ngModel)]="value" placeholder="0">
                    <a class="plusminus plus" (click)="handlePlus()"></a>
                  </div>
                </div>
                <div class="form-floating">
                  <span class="age-arrow">{{dataform.controls.Months.value | monthsToYear}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3 mt-md-5 align-items-center" [hidden]="!(showProvince)">
            <div class="col-md-2 type_data">Provincia</div>
            <div class="col-md-10">
              <ng-select2 formControlName="IdProvince" id="IdProvince" [data]="provinces" [placeholder]="'Provincias'" [allowClear]="true" class="select__region" [ngClass]="{ 'is-invalid': submitted && f.IdProvince.errors }">
              </ng-select2>
            </div>
            <div *ngIf="submitted && f.IdProvince.errors" class="col-md-10 offset-md-2">
              <div *ngIf="f.IdProvince.errors.required" class="invalid-feedback d-block">Provincia requerida</div>
            </div>
          </div>

          <div class="row mt-3 mt-md-5">
            <div class="col2 text-center"><button type="submit" class="btn btn-primary mb-3 mr-2">Siguiente</button></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>